import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { ContactId } from 'src/app/components/contact/store/contact.model';

@Component({
  selector: 'app-side-navigation-submenu-contact',
  templateUrl: './side-navigation-submenu-contact.component.html',
  styleUrls: ['./side-navigation-submenu-contact.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SideNavigationSubmenuContactComponent implements OnInit {
  tooltipDelay: number = 0.5;

  @Input() collapse: boolean = true;
  @Input() theme: string = 'light';
  @Input() contact: ContactId | any;
  @Output() select = new EventEmitter<string>(false);
  constructor() {}

  ngOnInit(): void {}

  onSelect(event: string): void {
    if (!event) return;
    this.select.emit(event);
  }
}
